var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "column-feeds" },
    [
      _vm.loading
        ? _c("VLoading")
        : !_vm.loading && _vm.cards.length === 0
        ? _c("VEmpty")
        : [
            _c(
              "div",
              { staticClass: "columns-feeds-content" },
              _vm._l(_vm.cards, function (c) {
                return _c("ColumnCard", {
                  key: c.id,
                  attrs: { "is-new": c.new, data: c },
                })
              }),
              1
            ),
            _vm._v(" "),
            _vm.hasMorePage
              ? _c("ScrollTrigger", {
                  on: {
                    trigger: function ($event) {
                      return _vm.nextPage()
                    },
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }